import React, { useEffect, useState } from 'react'
import { Col, Grid, Row } from 'react-flexbox-grid'
import * as Constants from '../../../../constants'
import { message } from 'antd'
import LoadingPage from '../../../components/LoadingPage'
import { editItemInventory, loadInventory } from '../../../../actions/inventory'
import { getInventory } from '../../../../reducers'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import FormVehicleInventory from '../../../containers/FormVehicleInventory'
import './styles.css'

const EditVehicle = (props) => {
    const [inventoryVehicle, setInventoryVehicle] = useState(null)
    const [isSaving, setIsSaving] = useState(false)

    useEffect(() => {
        const pathnameSplited = props?.location?.pathname?.split('/')
        if (pathnameSplited.length === 4) {
            const id = pathnameSplited[3]
            if (props.inventory) {
                if (props.inventory[id]) {
                    setInventoryVehicle(props.inventory[id])
                } else {
                    message.error('No se encontró el elemento seleccionado')
                    props.history.push(`/${Constants.MenuAdmin.INVENTORY.HOME}`)
                }
            }
        }
    }, [props.inventory])

    const getInventory = () => {
        props.loadInventory()
        return <LoadingPage/>
    }

    const handleSubmitEditVehicle = async values => {
        setIsSaving(true)
        const response = await props.editItemInventory(values)
        setIsSaving(false)
        if (response) {
            message.success('El vehículo se editó exitósamente')
            props.history.push(`/${Constants.MenuAdmin.INVENTORY.HOME}`)
        } else {
            message.error('Se produjo un error. Por favor, vuelva a intentarlo')
        }
    }

    const handleBack = () => {
        props.history.goBack()
    }

    return (
        <Grid className="editVehicleCont">
            {
                props.inventory ?
                    <div>
                        <Row center="xs">
                            <Col xs={12}>
                                Editar vehículo - Inventario
                            </Col>
                        </Row>
                        <br/>
                        <Row center="xs">
                            <Col xs={12}>
                                {
                                    inventoryVehicle ?
                                        <FormVehicleInventory loading={isSaving}
                                                              onSubmitVehicleInventory={handleSubmitEditVehicle}
                                                              isEditing={true} onBack={handleBack}
                                                              vehicleInventoryToEdit={inventoryVehicle}/>
                                        :
                                        null
                                }
                            </Col>
                        </Row>
                    </div>
                    :
                    getInventory()
            }
        </Grid>
    )
}

const mapDispatchToPropsActions = dispatch => ({
    loadInventory: value => dispatch(loadInventory(value)),
    editItemInventory: value => dispatch(editItemInventory(value))
})

const mapStateToProps = state => ({
    inventory: getInventory(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(EditVehicle))
